import React from 'react'

import * as S from '../styles'

interface ReadOnlyFieldProps {
  label: string
  value?: string | number | null
  valueColor?: string
}

const EMPTY_PLACEHOLDER = '-'

const formatValue = (value: ReadOnlyFieldProps['value']): string => {
  if (value === null || value === undefined) return EMPTY_PLACEHOLDER
  if (typeof value === 'string' && value.trim() === '') return EMPTY_PLACEHOLDER
  return String(value)
}

export function ReadOnlyField({ label, value, valueColor }: ReadOnlyFieldProps): JSX.Element {
  const formatted = formatValue(value)
  const shouldColorize = valueColor && formatted !== EMPTY_PLACEHOLDER

  return (
    <S.FieldWrapper>
      <S.FieldLabel>{label}</S.FieldLabel>
      <S.FieldValue $color={shouldColorize ? valueColor : undefined}>
        {formatted}
      </S.FieldValue>
    </S.FieldWrapper>
  )
}
